export const USERS_TABLE_HEADER_CONFIG = [
  {
    id: 1,
    field: "userName",
    minWidth: 191,
    type: "text",
    flex: 0.3,
  },
  {
    id: 2,
    field: "email",
    minWidth: 369,
    type: "mail",
    flex: 0.6,
  },
  {
    id: 3,
    field: "remove",
    minWidth: 66,
    type: "remove",
    flex: 0.1,
  },
];
